import { RecordedData } from "../types";
import dayjs from "dayjs";
import { encodeWav } from "./wav";
import { APP_NAME } from "../environments";

type VoiceTypesMap = Record<string, string | undefined>;

function appendVoiceFileData({
  formData,
  allRecordedData,
  fileKey,
  now,
  getVoiceTypesMap,
}: {
  formData: FormData;
  allRecordedData: RecordedData[];
  fileKey: "wav_files" | "files";
  now: string;
  getVoiceTypesMap: (recorded: RecordedData) => VoiceTypesMap;
}): void {
  for (
    let phraseIndex = 0;
    phraseIndex < allRecordedData.length;
    ++phraseIndex
  ) {
    const recorded = allRecordedData[phraseIndex];
    if (recorded.isSkipped) continue;

    const phrase = phraseIndex.toString().padStart(2, "0");
    // NOTE:アップロードされたファイルがあればそれを採用する（ファイル解析用）
    if (recorded.file) {
      formData.append(fileKey, recorded.file);
    } else {
      const wav = encodeWav(recorded.data, recorded.samplingRate);
      formData.append(fileKey, wav, `${phrase}_${now}.wav`);
    }

    // 音声タイプを formData に追加
    const voiceTypesMap = getVoiceTypesMap(recorded);
    const containsVoiceTypes = Object.entries(voiceTypesMap).filter(
      ([, value]) => {
        // 値なしをフィルタ
        return value != undefined;
      },
    );

    containsVoiceTypes.forEach(([voiceType, value]) => {
      formData.append(voiceType, value as string);
    });

    if (recorded.phrase) {
      formData.append("phrases", recorded.phrase);
    }
  }
}

export function generateVoiceFileData(
  allRecordedData: RecordedData[],
): FormData {
  const formData = new FormData();
  const now = dayjs().format("YYYY.MM.DD.HH.mm.ss");
  appendVoiceFileData({
    formData,
    allRecordedData,
    fileKey: "wav_files",
    now,
    getVoiceTypesMap: (recorded) => ({
      cog_voice_types: recorded.co1VoiceType,
      dysphagia_voice_types: recorded.dysphagiaVoiceTypes,
      br1_voice_types: recorded.br1VoiceType,
      sl1_voice_types: recorded.sl1VoiceType,
      co2_voice_types: recorded.co2VoiceType,
      co2_1_voice_types: recorded.co2_1VoiceType,
    }),
  });
  formData.append(
    "app_version",
    `${APP_NAME.replaceAll(" ", "_")}-${__GIT_DESCRIBE_REVISION__}`,
  );
  return formData;
}

export function generateCoreVoiceFileData(
  allRecordedData: RecordedData[],
): FormData {
  const formData = new FormData();
  const now = dayjs().format("YYYY.MM.DD.HH.mm.ss");
  appendVoiceFileData({
    formData,
    allRecordedData,
    fileKey: "files",
    now,
    getVoiceTypesMap: (recorded) => ({
      cog_voice_types: recorded.co1VoiceType,
      sl1_voice_types: recorded.sl1VoiceType,
      co2_voice_types: recorded.co2VoiceType,
      co2_1_voice_types: recorded.co2_1VoiceType,
    }),
  });
  return formData;
}
